import { sanitize } from "dompurify";
import { RankingConstants } from "../constants/RankingConstants";
import { ReplacementLoca } from "./i18n/ReplacementLoca";
import { utilLoca } from "./i18n/utilLoca";
import { utilNumber } from "./utilNumber";
var UtilTournament = /** @class */ (function () {
    function UtilTournament() {
    }
    UtilTournament.prototype.selectLocasFromIdLeagueDifficulty = function (idLeague) {
        var leagueNumber = Math.floor(idLeague / RankingConstants.LeagueDivisions);
        var position = idLeague % RankingConstants.LeagueDivisions;
        var leagueAsLoca = "league_" + leagueNumber;
        var translatedLeague = sanitize(utilLoca.get(leagueAsLoca));
        return new Map([
            [ReplacementLoca.zero_0, translatedLeague],
            [ReplacementLoca.one_1, utilNumber.format(position + 1)],
        ]);
    };
    return UtilTournament;
}());
export var utilTournament = new UtilTournament();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilTournament.ts
// module id = 2157
// module chunks = 3